// extracted by mini-css-extract-plugin
module.exports = {"h3":"News-module--h3--2OAhy","news_content":"News-module--news_content--2B50u","date":"News-module--date--108_n"};